export default "__VITE_ASSET__ifXmV7ND__"